import React from 'react';
import moment from 'moment';

class CustomDatePicker extends React.Component {

    render() {
        const { value } = this.props;
        return (
            <button type="button" className="btn btn-sm btn-info" onClick={this.props.onClick}>
                {value ? moment(this.props.value).format('MMM Do YYYY') : 'Select Date'}
            </button>
        )
    }
}
export default CustomDatePicker;


// WEBPACK FOOTER //
// ./src/components/partials/datepicker.js